import { render, staticRenderFns } from "./RedirectSVID.vue?vue&type=template&id=99f6017e&scoped=true&"
import script from "./RedirectSVID.vue?vue&type=script&lang=js&"
export * from "./RedirectSVID.vue?vue&type=script&lang=js&"
import style0 from "./RedirectSVID.vue?vue&type=style&index=0&id=99f6017e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f6017e",
  null
  
)

export default component.exports